{
  "eyebrow": "Choisissez votre formule",
  "title": "La formule qui correspond à votre équipe.",
  "sub": "30 jours d'essai gratuit sur toutes les formules. Sans carte bancaire. Annulez à tout moment.",
  "bill": {
    "month": "Mensuel",
    "year": "Annuel",
    "save": "15% d'économie"
  },
  "fam": {
    "time": "Temps & opérations",
    "project": "Projets & coûts"
  },
  "compare": "Comparer toutes les fonctionnalités",
  "compareHide": "Masquer le comparatif",
  "included": "Inclus",
  "select": "Choisir {{plan}}",
  "selected": "Sélectionné",
  "recommended": "Le plus populaire",
  "pricePerMonth": "/ utilisateur / mois",
  "pricePerYear": "/ utilisateur / an",
  "base": "base / mois",
  "admins": "2 administrateurs inclus",
  "continueCta": "Continuer avec {{plan}}",
  "continuePick": "Choisissez une formule pour continuer",
  "catalogError": "Catalogue de prix indisponible. Réessayez pour charger les derniers prix.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Conformité & suivi simple",
    "timeProBest": "Opérations d'équipe",
    "projectBasicBest": "Projets & contrôle des coûts",
    "projectProBest": "Gestion de projet avancée",
    "feat": {
      "timeBasic": {
        "timeTracking": "Enregistrement du temps",
        "absencesHolidays": "Absences & congés",
        "transport": "Journaux de transport",
        "workLocations": "Lieux de travail & GPS",
        "mobileApp": "Application mobile pour les travailleurs sur le terrain"
      },
      "timePro": {
        "everythingTime": "Tout ce qui est dans Time Basic",
        "overtime": "Suivi des heures supplémentaires",
        "scheduling": "Planification des équipes",
        "documents": "Documents des employés",
        "officeOps": "Fonctions de bureau (journal d'activité, corrections)",
        "addonsAvailable": "Modules disponibles : suivi de projet, VTT",
        "internalMessaging": "Messagerie interne (chat d'entreprise)"
      },
      "projectBasic": {
        "everythingTime": "Tout ce qui est dans Time Basic",
        "projects": "Projets avec contrôle des coûts",
        "extras": "Travaux & matériaux supplémentaires",
        "subcontractors": "Gestion des sous-traitants",
        "checkInOut": "Pointage entrée / sortie des employés",
        "internalMessaging": "Messagerie interne (chat d'entreprise)"
      },
      "projectPro": {
        "everythingAll": "Tout ce qui est dans Time Pro + Project Basic",
        "projectTransport": "Transport lié au projet",
        "fullSuite": "Suite complète de productivité",
        "prioritySupport": "Support prioritaire",
        "internalMessaging": "Messagerie interne (chat d'entreprise)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Comparer toutes les fonctionnalités",
    "subtitle": "Tout ce que chaque offre inclut, côte à côte.",
    "cat": {
      "timeAttendance": "Temps & présence",
      "projectCost": "Projet & contrôle des coûts",
      "support": "Assistance"
    },
    "val": {
      "upTo4": "Jusqu'à 4",
      "unlimited": "Illimité",
      "soon": "Bientôt",
      "optional": "En option",
      "years5": "5 ans",
      "years10": "10 ans"
    },
    "row": {
      "mobileDesktop": "Application mobile & bureau",
      "gpsCheckin": "Pointage en un clic avec GPS",
      "holidayAbsenceOvertime": "Congés, absences & heures suppl.",
      "teamMembers": "Membres de l'équipe",
      "workLocations": "Lieux de travail",
      "registrationsPerMonth": "Enregistrements / utilisateur / mois",
      "irregularMap": "Pointage irrégulier sur la carte",
      "expenseManagement": "Gestion des dépenses",
      "employeeDocuments": "Documents des employés",
      "openApi": "API ouverte",
      "navigation": "Navigation vers les sites",
      "projectManagement": "Gestion de projet (budget)",
      "subprojects": "Sous-projets",
      "subcontractorManagement": "Gestion des sous-traitants",
      "extraWorkMaterials": "Travaux & matériaux suppl.",
      "transportProjects": "Transport lié aux projets",
      "fullSuite": "Suite de productivité complète",
      "prioritySupport": "Assistance prioritaire",
      "languages12": "Disponible en 12 langues",
      "manualTransport": "Distance de transport manuelle",
      "reportsExcel": "Rapports et export Excel",
      "frontendLocations": "Lieux créés par les utilisateurs de l'app",
      "checkInWork": "Check-in/out@work (Belgique)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Descriptions et photos de projet",
      "dataStorage": "Stockage des données",
      "schedulingPlanning": "Planification",
      "messagingNotifications": "Messagerie · Notifications"
    }
  }
}
